// skipcq: JS-W1028
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';

/**
 * Default filled primary CTA — forest green via theme `palette.primary` and `MuiButton.containedPrimary`.
 */
function PrimaryActionButton({ sx, ...rest }) {
  return (
    <Button
      variant="contained"
      color="primary"
      sx={sx}
      {...rest}
    />
  );
}

PrimaryActionButton.propTypes = {
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
};

export default PrimaryActionButton;
